import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Auth } from './auth';

export const adminGuard: CanActivateFn = () => {
  const auth = inject(Auth);
  const router = inject(Router);

  if (!auth.isLoggedIn) {
    return router.parseUrl('/login');
  }

  if (auth.currentUser?.roles?.includes('admin')) {
    return true;
  }

  // Si no es admin, redirigir al dashboard
  return router.parseUrl('/dashboard');
};
